module.exports = __webpack_public_path__ + "img/1356727046_226603919.e21c900d.jpg";